import { render, staticRenderFns } from "./AreaPlantadaSojaCarMapbiomas.vue?vue&type=template&id=49fad444&lang=pug"
import script from "./AreaPlantadaSojaCarMapbiomas.vue?vue&type=script&lang=js"
export * from "./AreaPlantadaSojaCarMapbiomas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports